import { render } from "./index.vue?vue&type=template&id=38f18cc8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=38f18cc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f18cc8"],['__file',"src/views/BenefitsOffersDetails/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38f18cc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38f18cc8', __exports__)) {
    api.reload('38f18cc8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=38f18cc8&scoped=true", () => {
    api.rerender('38f18cc8', render)
  })

}


export default __exports__